export enum TnxLoadStatus {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  AWARDED = 'AWARDED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  ALL = 'ALL'
}
